import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const copyProductToAccount = unaryRpc({
  name: "copyProductToAccount" as const,
  input: z.object({
    sourceProductId: z.string(),
    targetTeamId: z.string(),
    locationId: z.string(),
    quantity: z.number(),
  }),
  output: z.object({ productId: z.string() }),
});
